(function () {
	var pauseIcon = "<svg class='textDkGray' width='30' height='30'><title>Pause Scrolling</title> <use xlink:href='#svgIcon-pause'></use> </svg>",
	playIcon = "<svg class='textDkGray rotate90' width='30' height='30'><title>Resume Scrolling</title> <use xlink:href='#svgIcon-arrowSolid'></use> </svg>",
	newsSignUpBtn = document.getElementById("signUpBtn"),
	homeSlider = tns({
		container: ".homeSlider",
		autoplay: true,
		speed: 1000,
		autoplayTimeout: 5500,
		//lazyload: true, //turning this off due to errors in IE ?
		controls: false,
		autoplayHoverPause: true,
		autoplayText: [
		    playIcon,
		    pauseIcon
		]
	}),
	submitThisForm = function(){
		// validate the email address, reusing the regex from registration
		var signupEmail = document.getElementById('signUpEmail').value;
		var filter = /^([\w-&]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,66}(?:\.[a-z]{2})?)$/i;
		if (signupEmail === "" || signupEmail === undefined || !filter.test(signupEmail)) {
			// invalid, show the error message and highlight the textbox
			document.getElementById("signUpEmail").classList.add("input-validation-error");
			document.getElementById("signUpEmail").setAttribute("aria-invalid", "true");
			document.getElementById("signUpEmail").removeAttribute("aria-labelledby");
			document.getElementById("signUpEmail").focus();
			document.getElementById("signUpError").classList.remove("hide");
			document.getElementById("signUpError").value = "Please enter a valid email address";
		} else {
			// valid, submit via AJAX
			document.getElementById("signUpBtn").classList.add("hide"); // hide btn and show loading img to prevent double submit and give a visual indicator to the user
			document.getElementById("signUpLoadingImg").classList.remove("hide");
			
			var newsSignUp = ajax({
                        method: "POST",
                        url: "/esp/signup",
                        data: { EmailAddress: signupEmail }
                    });
			newsSignUp.then(function (response, xhr) {
                        	document.getElementById("signUpForm").classList.add("hide");
				document.getElementById("signUpSuccessMsg").classList.remove("hide");
				document.getElementById("signUpSuccessMsg").innerHTML = '<p role="status" class="textsemibold">Thank you for signing up!</p><a id="emailOpts" href="/esp/?email=' + signupEmail + '">View all our email options</a>';
				document.getElementById("emailOpts").focus();
                    });
			newsSignUp.catch(function(response, xhr){
				document.getElementById("signUpError").classList.remove("hide");
				document.getElementById("signUpError").innerHTML = "Oops, something went wrong. Please submit again.";
				document.getElementById("signUpEmail").focus();
				document.getElementById("signUpBtn").classList.remove("hide");
				document.getElementById("signUpLoadingImg").classList.add("hide");
                    });
		}		
    	},
    	onLoadInit = function() {
    		setTimeout(function(){ 
			lazyloadImages.update(); 
			document.getElementById("mainSlider").classList.remove("invisible");
		}, 800);
    	},
    	initListeners = function() {
		newsSignUpBtn.addEventListener("click", function(e){
			e.preventDefault();
			submitThisForm();
	    	});
		newsSignUpBtn.addEventListener( "keyup", function(e){
			if(e.which == 13){ newsSignUpBtn.click(); }
		});
		window.addEventListener("load", function(){ onLoadInit(); });	
		if(!window.addEventListener && window.attachEvent){ window.attachEvent('load', onLoadInit);}
	};
	initListeners();
})();